exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".SourceHeaderRow___11O5s {\n  display: flex;\n  align-items: center;\n  min-height: 24px;\n}\n\n.SourceHeader___z9MSo {\n  flex: 1 1;\n  font-family: var(--font-family-sans);\n}\n\n.SourceOneLiner____wx6W {\n  font-family: var(--font-family-monospace);\n  font-size: var(--font-size-monospace-normal);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 100%;\n  margin-left: 1rem;\n}\n\n.Link___20whe {\n  color: var(--color-link);\n  white-space: pre;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  flex: 1;\n  cursor: pointer;\n  border-radius: 0.125rem;\n  padding: 0px 2px;\n}\n\n.Link___20whe:hover {\n  background-color: var(--color-background-hover);\n}\n", ""]);

// exports
exports.locals = {
	"SourceHeaderRow": "SourceHeaderRow___11O5s",
	"SourceHeader": "SourceHeader___z9MSo",
	"SourceOneLiner": "SourceOneLiner____wx6W",
	"Link": "Link___20whe"
};